import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';
export const isNativeApp = () => Capacitor.isNativePlatform();

function isDarkBackground(hex) {
  const value = hex.replace('#', '');
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}

export async function syncStatusBarWithBackground(backgroundColor) {
  if (!isNativeApp() || !backgroundColor) return;

  try {
    await StatusBar.setBackgroundColor({ color: backgroundColor });
    await StatusBar.setStyle({
      style: isDarkBackground(backgroundColor) ? Style.Light : Style.Dark,
    });
  } catch (err) {
    console.warn('StatusBar sync failed:', err);
  }
}

export async function openExternalUrl(url) {
  if (isNativeApp()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function shareContent({ title, text, url }) {
  const payload = { title, text, url, dialogTitle: title || 'Share' };

  if (isNativeApp()) {
    await Share.share(payload);
    return true;
  }

  if (navigator.share) {
    await navigator.share(payload);
    return true;
  }

  return false;
}

export async function initializeNativeApp(navigate) {
  if (!isNativeApp()) return () => {};

  try {
    await SplashScreen.hide();
    await StatusBar.setOverlaysWebView({ overlay: true });
    await syncStatusBarWithBackground('#000000');
  } catch (err) {
    console.warn('Native init failed:', err);
  }

  const openListener = await App.addListener('appUrlOpen', (event) => {
    try {
      const incoming = new URL(event.url);
      if (incoming.host !== 'truthbound.app') return;
      const path = `${incoming.pathname}${incoming.search}${incoming.hash}`;
      navigate(path || '/');
    } catch (err) {
      console.warn('Deep link parse failed:', err);
    }
  });

  return () => {
    openListener.remove();
  };
}